// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.dungeon-manager-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  z-index: 50;
}

.dungeon-manager-shell {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  position: relative;
  width: 1040px;
  max-width: 94%;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
}
.dungeon-manager-shell * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .dungeon-manager-shell {
    animation: none;
  }
}

.dungeon-manager-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}
.dungeon-manager-header__row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dungeon-manager-header__brand {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.dungeon-manager-header__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 2px 0 0;
}
.dungeon-manager-header__buttons {
  display: flex;
  gap: 8px;
}

.dungeon-manager-body {
  display: flex;
  gap: 20px;
  flex: 1;
  min-height: 0;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.dungeon-manager-list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  width: 260px;
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-right: 14px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}
.dungeon-manager-list::-webkit-scrollbar {
  width: 6px;
}
.dungeon-manager-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.dungeon-manager-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-left: 2px solid transparent;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.dungeon-manager-list-item:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
}
.dungeon-manager-list-item:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.dungeon-manager-list-item--selected {
  color: var(--gold-light);
  background: rgba(255, 255, 255, 0.07);
  border-left-color: var(--gold-main);
}
.dungeon-manager-list-item__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dungeon-manager-phase-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: none;
  background: #8d8a82;
}
.dungeon-manager-phase-dot--active {
  background: #8fbf8a;
}
.dungeon-manager-phase-dot--resetting {
  background: var(--gold-main);
}

.dungeon-manager-detail {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-right: 4px;
}
.dungeon-manager-detail::-webkit-scrollbar {
  width: 6px;
}
.dungeon-manager-detail::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.dungeon-manager-section {
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.dungeon-manager-section--danger-zone {
  border-bottom: 0;
  padding-bottom: 0;
}
.dungeon-manager-section__heading {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  display: block;
  margin-bottom: 8px;
}

.dungeon-manager-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.dungeon-manager-input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: auto;
  padding: 7px 10px;
}
.dungeon-manager-input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.dungeon-manager-input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.dungeon-manager-input--small {
  width: 90px;
}

.dungeon-manager-timer-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dungeon-manager-timer-field__label {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}

.dungeon-manager-meta {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin-top: 8px;
}

.dungeon-manager-loot-list {
  display: flex;
  flex-direction: column;
  margin-top: 6px;
}

.dungeon-manager-loot-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.dungeon-manager-loot-row:last-child {
  border-bottom: 0;
}
.dungeon-manager-loot-row__refrid {
  width: 90px;
  font-family: monospace;
  font-size: 13px;
  color: #aeaba2;
}
.dungeon-manager-loot-row__count {
  flex: 1;
  font-size: 14px;
}

.dungeon-manager-confirm-text {
  font-size: 14px;
  color: #d9786d;
}

.dungeon-manager-empty {
  padding: 12px 0;
  font-size: 14px;
  color: #8d8a82;
}

.dungeon-manager-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.dungeon-manager-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.dungeon-manager-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.dungeon-manager-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.dungeon-manager-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.dungeon-manager-btn--small {
  padding: 5px 10px;
  font-size: 13px;
}
.dungeon-manager-btn--secondary {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.dungeon-manager-btn--secondary:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.dungeon-manager-btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.dungeon-manager-btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/DungeonManager/DungeonManager.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDcU;ECbV,WAAA;AAMF;;AAHA;EDaE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECvJA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAYF;ADPE;EAAI,sBAAA;ACUN;ADmIE;EC5JF;ID4J4C,eAAA;EC/H1C;AACF;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAoBF;AAlBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAoBJ;AAjBE;EDyBA,eAAA;EACA,gBAAA;EACA,cAlDO;AC6CT;AAlBE;EDMA,kDA3BW;EA4BX,gBAAA;EACA,eCPqB;EDQrB,iBAAA;EACA,sBAAA;EACA,cAxCK;EC+BH,eAAA;AAyBJ;AAtBE;EACE,aAAA;EACA,QAAA;AAwBJ;;AApBA;EACE,aAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,iBAAA;EACA,+CAAA;AAuBF;;AApBA;ED+FE,gBAAA;EACA,qBAAA;EACA,qDAAA;EC/FA,YAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,iDAAA;AAyBF;ADkEE;EAAuB,UAAA;AC/DzB;ADgEE;EAA6B,oCAAA;EAAsC,kBAAA;AC5DrE;;AA7BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;EACA,yDDzDU;EC0DV,eAAA;EACA,gBAAA;EACA,cDpEO;ECqEP,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,0BAAA;EACA,eAAA;EACA,yDAAA;AAgCF;AA9BE;EAAU,cD7EL;EC6EuB,qCDjFjB;ACmHb;AAjCE;EAAkB,oCAAA;EAAsC,oBAAA;AAqC1D;AAnCE;EACE,wBAAA;EACA,qCAAA;EACA,mCAAA;AAqCJ;AAlCE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAoCJ;;AAhCA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,mBDhGO;ACmIT;AAjCE;EAAY,mBDhGJ;ACoIV;AAnCE;EAAe,4BAAA;AAsCjB;;AAnCA;EDwCE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECxCA,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAwCF;ADHE;EAAuB,UAAA;ACMzB;ADLE;EAA6B,oCAAA;EAAsC,kBAAA;ACSrE;;AA5CA;EACE,oBAAA;EACA,kDAAA;AA+CF;AA7CE;EACE,gBAAA;EACA,iBAAA;AA+CJ;AA5CE;EDnEA,eAAA;EACA,gBAAA;EACA,cAzDO;EC4HL,cAAA;EACA,kBAAA;AAgDJ;;AA5CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA+CF;;AA5CA;EDrBE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECeA,WAAA;EACA,iBAAA;AAuDF;ADrEE;EAAU,aAAA;EAAe,8BAAA;ACyE3B;ADxEE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC+E1G;AAhEE;EAAW,WAAA;AAmEb;;AAhEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAmEF;AAjEE;EDpGA,eAAA;EACA,gBAAA;EACA,cAlDO;AC0NT;;AAjEA;EDzGE,eAAA;EACA,gBAAA;EACA,cAlDO;EC2JP,eAAA;AAsEF;;AAnEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAsEF;;AAnEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,kDAAA;AAsEF;AApEE;EAAe,gBAAA;AAuEjB;AArEE;EACE,WAAA;EACA,sBAAA;EACA,eAAA;EACA,cDlLK;ACyPT;AApEE;EACE,OAAA;EACA,eAAA;AAsEJ;;AAlEA;EACE,eAAA;EACA,cD3LO;ACgQT;;AAlEA;EACE,eAAA;EACA,eAAA;EACA,cDlMO;ACuQT;;AAhEA;ED1IE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;AC8MF;AD5ME;EAAyB,qCAAA;EAAuC,8BAAA;ACgNlE;AD/ME;EAA0B,0BAAA;ACkN5B;ADjNE;EAAa,YAAA;EAAc,mBAAA;ACqN7B;ADpNE;EAAkB,oCAAA;EAAsC,mBAAA;ACwN1D;AA/FE;ED7FA,iBAAA;EACA,eAAA;AC+LF;AAlGE;EDtGA,cArGO;EAsGP,uBAAA;EACA,yBAAA;AC2MF;ADzME;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC8MhF;AA3GE;ED/GA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;AC6NF;AD3NE;EAAyB,qCAAA;EAAuC,qBAhGzD;AC+TT","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Dungeon manager: centred ink window, list on the left, detail sections on\n// the right separated by headings and spacing (no nested cards).\n\n.dungeon-manager-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 8, 0.6);\n  pointer-events: none;\n  font-family: ink.$font-text;\n  z-index: 50;\n}\n\n.dungeon-manager-shell {\n  @include ink.panel;\n  @include ink.enter;\n  pointer-events: auto;\n  position: relative;\n  width: 1040px;\n  max-width: 94%;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 24px;\n}\n\n.dungeon-manager-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n\n  &__row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__brand {\n    @include ink.hint;\n  }\n\n  &__title {\n    @include ink.title(24px);\n    margin: 2px 0 0;\n  }\n\n  &__buttons {\n    display: flex;\n    gap: 8px;\n  }\n}\n\n.dungeon-manager-body {\n  display: flex;\n  gap: 20px;\n  flex: 1;\n  min-height: 0;\n  padding-top: 14px;\n  border-top: 1px solid ink.$line;\n}\n\n.dungeon-manager-list {\n  @include ink.scroll;\n  width: 260px;\n  flex: none;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-right: 14px;\n  border-right: 1px solid ink.$line;\n}\n\n.dungeon-manager-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  font-family: ink.$font-text;\n  font-size: 14px;\n  text-align: left;\n  color: ink.$text-2;\n  background: transparent;\n  border: 0;\n  border-left: 2px solid transparent;\n  border-radius: 0 ink.$radius ink.$radius 0;\n  cursor: pointer;\n  transition: background-color 0.12s ease, color 0.12s ease;\n\n  &:hover { color: ink.$text; background: ink.$ink-raised; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n\n  &--selected {\n    color: var(--gold-light);\n    background: rgba(255, 255, 255, 0.07);\n    border-left-color: var(--gold-main);\n  }\n\n  &__name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.dungeon-manager-phase-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex: none;\n  background: ink.$text-3;\n\n  &--active { background: ink.$success; }\n  &--resetting { background: var(--gold-main); }\n}\n\n.dungeon-manager-detail {\n  @include ink.scroll;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding-right: 4px;\n}\n\n.dungeon-manager-section {\n  padding-bottom: 18px;\n  border-bottom: 1px solid ink.$line;\n\n  &--danger-zone {\n    border-bottom: 0;\n    padding-bottom: 0;\n  }\n\n  &__heading {\n    @include ink.label;\n    display: block;\n    margin-bottom: 8px;\n  }\n}\n\n.dungeon-manager-inline {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dungeon-manager-input {\n  @include ink.field;\n  width: auto;\n  padding: 7px 10px;\n\n  &--small { width: 90px; }\n}\n\n.dungeon-manager-timer-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  &__label {\n    @include ink.hint;\n  }\n}\n\n.dungeon-manager-meta {\n  @include ink.hint;\n  margin-top: 8px;\n}\n\n.dungeon-manager-loot-list {\n  display: flex;\n  flex-direction: column;\n  margin-top: 6px;\n}\n\n.dungeon-manager-loot-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 0;\n  border-bottom: 1px solid ink.$line;\n\n  &:last-child { border-bottom: 0; }\n\n  &__refrid {\n    width: 90px;\n    font-family: monospace;\n    font-size: 13px;\n    color: ink.$text-2;\n  }\n\n  &__count {\n    flex: 1;\n    font-size: 14px;\n  }\n}\n\n.dungeon-manager-confirm-text {\n  font-size: 14px;\n  color: ink.$danger;\n}\n\n.dungeon-manager-empty {\n  padding: 12px 0;\n  font-size: 14px;\n  color: ink.$text-3;\n}\n\n// Neutral by default, --secondary is the quiet tertiary kind, --danger for\n// destructive actions.\n.dungeon-manager-btn {\n  @include ink.button;\n\n  &--small { @include ink.button-sm; }\n  &--secondary { @include ink.button-quiet; }\n  &--danger { @include ink.button-danger; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
